import { useTranslation } from 'next-i18next';
import Heading from '@components/Heading/Heading';
import styles from '@features/showrooms/sections/ShowroomSection/Components/ShowroomOffer/ShowroomOffer.styles';
import sanitizeHtml from '@utils/sanitizeHtml';
type PropsType = {
  description: string | null;
};
const ShowroomCard = ({
  description
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  return <div sx={styles.showroomOffer}>
      <Heading h={2} size={40} uppercase mobile>
        {t('showroomOffer')}
      </Heading>
      <div dangerouslySetInnerHTML={sanitizeHtml(description || '')} />
    </div>;
};
export default ShowroomCard;